import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStatamentStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  allocation: {
    borderBottom: "1px solid ".concat(palette.shades[300]),
    boxShadow: palette.shadows.light,
    borderRadius: '2px'
  },
  allocationButton: {
    borderLeft: "1px solid ".concat(palette.shades[300]),
    padding: '12px 16px',
    width: '220px',
    '& .MuiButton-root': {
      border: "1px solid ".concat(palette.shades[300])
    }
  },
  accordion: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiAccordionSummary-root': {
      flexDirection: 'row-reverse',
      minHeight: '60px',
      padding: '0 32px'
    }
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  },
  actionsButton: {
    marginLeft: '10px'
  },
  actionsButtons: {
    display: 'flex'
  },
  billTable: {
    border: "1px solid ".concat(palette.shades[300]),
    margin: '23px',
    width: '720px'
  },
  bodyTable: {
    background: palette.shades[200],
    borderTop: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '60px'
  },
  chip: {
    marginLeft: '5px'
  },
  disabled: {
    opacity: '0.5'
  },
  headerTable: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 16px'
  },
  leftSpace: {
    marginLeft: '20px'
  },
  title: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: '1'
  },
  utility: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px 8px 24px',
    width: '100%'
  },
  utilityInfo: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  utilityText: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column'
  },
  flexWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  utilityCap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '8px',
    flexShrink: '0',
    '& span': {
      marginLeft: '4px'
    }
  }
}));
export default useStatamentStyles;